module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_iterators.js
 ** module id = 23
 ** module chunks = 0
 **/